document.addEventListener("DOMContentLoaded", function () {
  document.body.addEventListener("click", async function (e) {
    const loadMoreBtn = e.target.closest(".js-load-more-results");
    if (!loadMoreBtn) return;

    e.preventDefault();

    const href = loadMoreBtn.getAttribute("href");
    if (!href) return;

    const span = loadMoreBtn.querySelector("span") || loadMoreBtn;
    const originalText = span.textContent.trim();

    if (!loadMoreBtn.hasAttribute("data-original-text")) {
      loadMoreBtn.setAttribute("data-original-text", originalText);
    }

    const loadingText = loadMoreBtn.getAttribute("data-loading-text") || "Ładowanie...";
    span.textContent = loadingText;

    try {
      const response = await fetch(href);
      if (!response.ok) throw new Error("Błąd ładowania treści");

      const htmlText = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlText, "text/html");

      const newResults = doc.querySelector(".js-collection-results");
      const currentResults = document.querySelector(".js-collection-results");

      if (newResults && currentResults) {
        Array.from(newResults.children).forEach(child => {
          currentResults.appendChild(child);
        });
      }

      const newLoadMore = doc.querySelector(".js-load-more-results");

      if (!newLoadMore.parentElement.classList.contains("d-none")) {
        const newHref = newLoadMore.getAttribute("href");
        if (newHref) {
          loadMoreBtn.setAttribute("href", newHref);
        }

        const newOriginalText = loadMoreBtn.getAttribute("data-original-text") || originalText;
        span.textContent = newOriginalText;

        loadMoreBtn.parentElement.classList.remove("d-none");
      } else {
        loadMoreBtn.parentElement.classList.add("d-none");
      }

      if (window.innerWidth > 991 && typeof initParallax === 'function') {
        initParallax();
      }

      if(typeof initializeObservers === 'function') {
        initializeObservers();
      }

      if(typeof updateBackgroundParallax === 'function') {
        updateBackgroundParallax();
      }

      document.querySelectorAll('.js-media-counter').forEach((el, index) => {
        el.innerHTML = index + 1;
      });
    } catch (error) {
      console.error("Błąd podczas ładowania wyników:", error);
      span.textContent = loadMoreBtn.getAttribute("data-original-text") || originalText;
    }
  });
});